import { render, staticRenderFns } from "./company-skills-input.vue?vue&type=template&id=1341f90c&lang=pug&"
import script from "./company-skills-input.vue?vue&type=script&lang=js&"
export * from "./company-skills-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports